import {Marshal} from "./marshal";
import {Cursor} from "./cursor";

export interface IDebugController {
    addPauseState: (state: string) => void
    clearLog: () => void
    getLog: () => string[]
    getPaused: (state: string) => boolean
    getPausedStates: () => string []
    handleEnterState: (state: string, cursor: Cursor) => void
    handleExecuteAction: (marshal: Marshal, cursor: Cursor) => void
    removePauseState: (state: string) => void
}

export class DebugController implements IDebugController {
    readonly pauseStates: string[] = [];
    readonly log: string[] = [];
    readonly maxLogLength = 100;

    addPauseState(state: string) {
        if (! this.pauseStates.includes(state)) {
            this.pauseStates.push(state);
        }
    }
    clearLog() {
        this.log.length = 0;
    }
    getLog(): string [] {
        return this.log;
    }
    getPaused(state: string): boolean {
        return this.pauseStates.includes(state);
    }
    getPausedStates(): string [] {
        return this.pauseStates;
    }
    handleEnterState(state: string, cursor: Cursor): void {
        this.addLog(`Entering ${state}`);
    }
    handleExecuteAction(marshal: Marshal, cursor: Cursor): void {
        this.addLog(`Executing ${marshal.action} with ${Object.keys(marshal.parameters).map(parameter =>
            `${parameter}: ${marshal.parameters[parameter].value(cursor)}`
        ).join(', ')}`);
    }
    removePauseState(state: string) {
        const index = this.pauseStates.indexOf(state);

        if (index >= 0) {
            this.pauseStates.splice(index, 1);
        }
    }
    private addLog(line: string) {
        this.log.push(line);
        if (this.log.length > this.maxLogLength) {
            this.log.splice(0, 1);
        }
    }
}